import(/* webpackMode: "eager" */ "/codebuild/output/src2174506986/src/pitch-perfect-frontend/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2174506986/src/pitch-perfect-frontend/app/providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2174506986/src/pitch-perfect-frontend/components/wrapper/AppInitialIzer.ts");
